import { createReducer } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { clearAllProjectData } from '../actions/clearAllProjectData';
import longDescriptionUpdated from '../actions/longDescriptionUpdated';
import resetCalculationDataForDocument from '../actions/resetCalculationDataForDocument';

export const getLongDescriptionByDocumentAndAdjustment =
  (documentCode, adjustmentKey) => (state) =>
    state.longDescriptionsByCode[documentCode][adjustmentKey];

const longDescriptionReducer = createReducer(
  {},
  {
    [longDescriptionUpdated]: (state, action) => {
      if (
        !action.payload ||
        !action.payload.shortDescription ||
        !action.payload.longDescription ||
        !action.payload.documentCode
      ) {
        return state;
      }

      const { documentCode, shortDescription, longDescription } =
        action.payload;
      const codeDescriptions = cloneDeep(state)[documentCode] || {};
      codeDescriptions[shortDescription] = longDescription;

      return {
        ...state,
        [documentCode]: codeDescriptions,
      };
    },
    [resetCalculationDataForDocument]: (state, action) => {
      if (!action.payload || !action.payload.documentCode) {
        return state;
      }
      const { documentCode } = action.payload;
      delete state[documentCode];
      return state;
    },
    [clearAllProjectData]: () => ({}),
  }
);

export default longDescriptionReducer;
